<template>
  <div class=" core_form_box" :class="[classesforAlign,classesforDirection,classesforEditable]">
    <div class="core_form__head fx__border" :hidden="hideTitle">
      <div class="slot">{{ title }}</div>
    </div>
    <div class="core_form__body">
      <slot></slot>
    </div>
  </div>
</template>
<script>
// const prefixCls = "core";
const prefixCls = "core_form";

export default {
  name: "iForm",
  data() {
    return {
      Col: null,
      fields: [],
      conten: {}
    };
  },
  provide() {
    return {
      col: this.col,
      labelWidthbyForm: this.labelWidth,
      conten: this.conten,
      form: this
    };
  },
  props: {
    //可编辑
    editable: {
      type: Boolean,
      default: true
    },
    // 表单数据对象
    model: {
      type: Object
    },
    // 组件的标题
    title: {
      type: String,
      default: ""
    },
    // 分多少列
    col: {
      type: [Number, String]
    },
    //label文字排列
    labelAlign: {
      validator(value) {
        let arr = ["left", "right"];
        return arr.includes(value);
      },
      default: "right"
    },
    // label方向
    labelDirection: {
      validator(value) {
        let arr = ["horizontal", "vertical"];
        return arr.includes(value);
      },
      default: "horizontal"
    },
    //label长度
    labelWidth: {
      type: [Number, String]
    },
    //验证规则
    rules: {
      type: Object
    },
    //是否显示验证信息
    showMessage: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    //label对齐方式
    classesforAlign() {
      return [`${prefixCls}_label-${this.labelAlign}`];
    },
    //label方向
    classesforDirection() {
      return [`${prefixCls}_label-${this.labelDirection}`];
    },
    //表单是否可编辑
    classesforEditable() {
      if (this.editable) {
        return [`${prefixCls}-editable`];
      } else {
        return [`${prefixCls}-uneditable`];
      }
    },
    hideTitle() {
      if (!this.title) {
        return true;
      }
    }
  },
  watch: {
    rules() {
      this.validate();
      // handler(newVal, ldVal) {
      //   this.validate();
      // },
      // immediate: true
    }
  },
  methods: {
    resetFields() {
      this.fields.forEach(field => {
        field.resetField();
      });
    },
    validate(callback) {
      return new Promise(resolve => {
        let valid = true;
        let count = 0;
        this.fields.forEach(field => {
          field.validate("", errors => {
            if (errors) {
              valid = false;
            }
            if (++count === this.fields.length) {
              // all finish
              resolve(valid);
              if (typeof callback === "function") {
                callback(valid);
              }
            }
          });
        });
      });
    },
    validateField(prop, cb) {
      const field = this.fields.filter(field => field.prop === prop)[0];
      if (!field) {
        throw new Error(
          "[iView warn]: must call validateField with valid prop string!"
        );
      }

      field.validate("", cb);
    }
  },
  created() {
    this.$on("on-form-item-add", field => {
      if (field) this.fields.push(field);
      return false;
    });
    this.$on("on-form-item-remove", field => {
      if (field.prop) this.fields.splice(this.fields.indexOf(field), 1);
      return false;
    });
  }
};
</script>
<style lang="scss">
@import "./form.scss";
</style>
